export class ModalCriarNovoPedidoController {
  constructor($uibModalInstance, criar) {
    "ngInject";

    this.$instance = $uibModalInstance;
    this.criar = criar;
  }

  nao() {
    this.$instance.dismiss('cancel');
  }

  sim() {
    this.criar = true;
    this.$instance.close(criar);
  }
}

export class ModalCriarNovoPedidoController2 {
  constructor($scope, $rootScope, $uibModalInstance) {
    $scope.nao = function() {
      $uibModalInstance.dismiss('cancel');
    };
  
    $scope.sim = function() {
      $rootScope.$broadcast('pedido:cancelar');
      $uibModalInstance.dismiss('cancel');
    };
  }
}
